enum SkillType {
  DOLLAR_A_DAY = 'Dollar A Day',
  QUICK_SAVE = 'Quick Save',
  ROUND_UP = 'Round Up',
  SAVE_A_FORTUNE = 'Save A Fortune',
  SAVE_A_SLICE = 'Save A Slice',
  WEEKLY_SAVER = 'Weekly Saver',
}

export default SkillType;
